import { Typography, Grid, Alert, Snackbar } from "@mui/material";
import Modal from "../../../components/Modal/Modal";
import {
  useIsFetching,
  useIsMutating,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { removeAdmin } from "../../../hooks/useAdmins";
import { useLocation, useNavigate } from "react-router-dom";
import { resetDriverPasswordAndResendInviteEmail } from "../../../hooks/useDrivers";

const DriverResetPasswordModal = ({
  accessToken,
  selectedDriver,
  setSelectedDriver,
  open,
  setOpen,
}: {
  accessToken: string;
  selectedDriver: any;
  setSelectedDriver: Dispatch<SetStateAction<any>>;
  open: boolean;
  setOpen: any;
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { data } = await resetDriverPasswordAndResendInviteEmail({
        accessToken,
        userId: selectedDriver?.id,
      });
      console.log("success data", data);
      setShowSuccess(true);
      setOpen(false);
      setSelectedDriver(null);
    } catch (error: any) {
      setSubmitError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={Boolean(submitError)}
        autoHideDuration={6000}
        onClose={(reason) => {
          console.log("reason", reason);
          setSubmitError("");
        }}
      >
        <Alert
          onClose={() => {
            setSubmitError("");
          }}
          severity="error"
          sx={{ width: "100%" }}
        >
          {submitError}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={showSuccess}
        autoHideDuration={6000}
        onClose={() => {
          setShowSuccess(false);
        }}
      >
        <Alert
          onClose={() => {
            setShowSuccess(false);
          }}
          severity="success"
          sx={{ width: "100%" }}
        >
          The driver's password has been reset and they've been sent an email
          with further instructions.
        </Alert>
      </Snackbar>
      <Modal
        open={open}
        loading={loading}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        handleClose={handleClose}
        title={`Confirm driver password reset for ${selectedDriver?.firstName ?? ""} ${selectedDriver?.lastName ?? ""}`}
        submitButtonLabel="Remove"
      >
        <Grid item>
          <Typography>
            This action will reset the driver's password and resend them an
            email with instructions on how to log in to the app. Doing this will
            kick the driver out of the app if they're already logged in. Are you
            sure you'd like to continue?
          </Typography>
        </Grid>
      </Modal>
    </>
  );
};

export default DriverResetPasswordModal;
